import React from 'react'

const UrgentIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_950_8440"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="23"
        height="22"
      >
        <rect x="0.333984" width="22" height="22" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_950_8440)">
        <path
          d="M11.3346 15.5859C11.5944 15.5859 11.8121 15.4981 11.9878 15.3224C12.1635 15.1467 12.2513 14.929 12.2513 14.6693C12.2513 14.4095 12.1635 14.1918 11.9878 14.0161C11.8121 13.8405 11.5944 13.7526 11.3346 13.7526C11.0749 13.7526 10.8572 13.8405 10.6815 14.0161C10.5058 14.1918 10.418 14.4095 10.418 14.6693C10.418 14.929 10.5058 15.1467 10.6815 15.3224C10.8572 15.4981 11.0749 15.5859 11.3346 15.5859ZM10.418 11.9193H12.2513V6.41927H10.418V11.9193ZM11.3346 20.1693C10.0666 20.1693 8.87491 19.9286 7.75964 19.4474C6.64436 18.9661 5.67422 18.313 4.84922 17.488C4.02422 16.663 3.37109 15.6929 2.88984 14.5776C2.40859 13.4623 2.16797 12.2707 2.16797 11.0026C2.16797 9.73455 2.40859 8.54288 2.88984 7.4276C3.37109 6.31233 4.02422 5.34219 4.84922 4.51719C5.67422 3.69219 6.64436 3.03906 7.75964 2.55781C8.87491 2.07656 10.0666 1.83594 11.3346 1.83594C12.6027 1.83594 13.7944 2.07656 14.9096 2.55781C16.0249 3.03906 16.9951 3.69219 17.8201 4.51719C18.6451 5.34219 19.2982 6.31233 19.7794 7.4276C20.2607 8.54288 20.5013 9.73455 20.5013 11.0026C20.5013 12.2707 20.2607 13.4623 19.7794 14.5776C19.2982 15.6929 18.6451 16.663 17.8201 17.488C16.9951 18.313 16.0249 18.9661 14.9096 19.4474C13.7944 19.9286 12.6027 20.1693 11.3346 20.1693ZM11.3346 18.3359C13.3819 18.3359 15.1159 17.6255 16.5367 16.2047C17.9576 14.7839 18.668 13.0498 18.668 11.0026C18.668 8.95538 17.9576 7.22135 16.5367 5.80052C15.1159 4.37969 13.3819 3.66927 11.3346 3.66927C9.28741 3.66927 7.55339 4.37969 6.13255 5.80052C4.71172 7.22135 4.0013 8.95538 4.0013 11.0026C4.0013 13.0498 4.71172 14.7839 6.13255 16.2047C7.55339 17.6255 9.28741 18.3359 11.3346 18.3359Z"
          fill="#EB5D60"
        />
      </g>
    </svg>
  )
}

export default UrgentIcon
